import { Typography, Theme } from '@mui/material';
import { SxProps } from '@mui/system';

export const REQUIRED_FIELDS_MESSAGE = 'Fields marked with an asterisk (*) are required.';

export function RequiredFieldsMessage({ sx }: { sx?: SxProps<Theme> }): JSX.Element {
  return (
    <Typography
      variant="body2"
      component="p"
      sx={{ fontSize: 13, color: 'rgba(0,0,0,0.7)', mb: 1, ...sx }}>
      {REQUIRED_FIELDS_MESSAGE}
    </Typography>
  );
}
